export class Consulta {
    constructor(data) {
      this.idConsulta = data.idConsulta;
      this.nombre = data.nombre;
      this.primerApellido = data.apellidos;
      this.segundoApellido = "";
      this.tipoDeDocumento = data.tipoDeDocumento;
      this.documentoIdentificacion = data.documentoIdentificacion;
      this.telefonoMovil = data.telefonoMovil;
      this.correoElectronico = data.correoElectronico;
      this.sexo = data.sexo;
      this.pais = "España";
      this.codigoPostal = data.codigoPostal;
      this.fechaNacimiento = "2000-01-01";
      this.temaConsulta = data.temaConsulta;
      this.textoConsulta = data.textoConsulta; 
      this.descripcionAdjunto = data.descripcionAdjunto;
    }
  }